import { EMPTY_FIELD } from 'constants/emptyField';

import { useTypedTranslate } from 'providers/i18n/hooks/useTypedTranslate';
import { Box } from 'shared/mui/Box';
import { Typography } from 'shared/mui/Typography';
import { TextField } from 'shared/react-admin/Fields';

import { GatewayRuleMappingDescriptionField } from './GatewayRuleMappingDescriptionField';

export const GatewayRuleMappingAdditionalFields: React.FC = () => {
  const translate = useTypedTranslate();

  return (
    <>
      <Box sx={{ textWrap: 'nowrap' }}>
        <Typography component="span" mr={1} variant="subtitle2">
          {`${translate('app.table.order')}:`}
        </Typography>
        <TextField source="sortOrder" />
      </Box>
      <GatewayRuleMappingDescriptionField />
      <Box sx={{ display: 'flex', alignItems: 'center' }}>
        <Typography component="span" variant="subtitle2">
          {`${translate('app.gatewayRules.methodMerchantsName')}: `}
          <TextField
            emptyText={EMPTY_FIELD}
            mr={1}
            source="merchantLabel"
            sx={{ whiteSpace: 'wrap' }}
          />
        </Typography>
      </Box>
    </>
  );
};
